import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";
import { toast } from "sonner";

export const UpdatePrompt = () => {
  const [needsUpdate, setNeedsUpdate] = useState(false);
  const [registration, setRegistration] = useState<ServiceWorkerRegistration | null>(null);

  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.ready.then((reg) => {
        setRegistration(reg);
        
        reg.addEventListener("updatefound", () => {
          const newWorker = reg.installing;
          if (newWorker) {
            newWorker.addEventListener("statechange", () => {
              if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
                setNeedsUpdate(true);
              }
            });
          }
        });
      });

      // Check for updates periodically
      const interval = setInterval(() => {
        registration?.update();
      }, 60 * 60 * 1000); // Check every hour

      return () => clearInterval(interval);
    }
  }, [registration]);

  const handleUpdate = () => {
    if (registration?.waiting) {
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
      window.location.reload();
    }
  };

  useEffect(() => {
    if (needsUpdate) {
      toast("Update Available", {
        description: "A new version of Strata is available.",
        action: {
          label: "Update",
          onClick: handleUpdate,
        },
        duration: Infinity,
        icon: <RefreshCw className="h-4 w-4" />,
      });
    }
  }, [needsUpdate]);

  return null;
};
